export { Car as HCCar } from './Car';
